export default "__VITE_ASSET__C5d3oxSP__"